import React from 'react';
import { AccessControl } from '@nile/components';
import { Button } from '@superops/ui-design-system';
import { SVGIcon } from '@superops/super-icons';
const CreateCustomViewButton = ({ roleToCheck, onClick }) => {
  const button = (
    <Button
      icon={<SVGIcon name="Add" />}
      onClick={onClick}
      plain
      monochrome
      iconColor="#0A0B10"
    />
  );
  return <AccessControl roleToCheck={roleToCheck} render={button} />;
};
export default CreateCustomViewButton;
